import { createFileRoute } from '@tanstack/react-router'
import TerminalLogin from '@/features/auth/terminal-login/TerminalLogin'

// The N.E.S.T. monochrome terminal login fronts the Cognito auth flow
// (email/password in-app, Apple/Google via identity_provider redirect, and
// passkey/Face-ID via WebAuthn). The _authenticated guard routes here.
export const Route = createFileRoute('/(auth)/sign-in')({
  component: TerminalLogin,
})
